var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"menu__item__link",class:{'menu__item__link--highlight' : _vm.highlight}},_vm.$listeners),[_c('span',{staticClass:"menu__item__inner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }